export enum CopyType {
  ALL,
  COL,
  ROW,
}
